import type {
  CoreInsuranceResponseList,
  CoreInsuranceStatus,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get all insurances for logged user.
 *
 * @endpoint GET /api/saas/me/insurances
 * @scope saas
 * @see https://flecto.dev/api-4724221
 */
export async function getAllInsurances(
  options?: GetAllInsurancesOptions
): Promise<CoreInsuranceResponseList> {
  const response = await api.get('/api/saas/me/insurances', { params: options })

  return response.data
}

export type GetAllInsurancesOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  start_date?: string
  end_date?: string
  meta_status?: CoreInsuranceStatus[]
  sort?:
    | 'id'
    | 'booking_id'
    | 'item_id'
    | 'created_at'
    | 'price_cents'
    | 'start_at'
    | 'end_at'
    | 'meta_status'
    | 'policy_type'
  policy_type?: 'regular' | 'early_pickup' | 'extension'
}
